import { FC, useMemo } from "react"
import { useTranslation } from "react-i18next"
import { StarIcon, Ton3dIcon } from "@/assets"
import { friendsHeroSrc } from "@/assets/images/referrals/_index"
import { showToast } from "@/helpers/toast"
import { useAppSelector } from "@/store"
import { useGetMyInfluencerQuery } from "@/store/apis/referralAPI"
import { AppSelectors } from "@/store/slices/app"
import { Button } from "@/ui/Button"
import { buildReferralLinks, shareReferral } from "../../helpers"
import styles from "./InviteHero.module.scss"

export const InviteHero: FC = () => {
  const { t } = useTranslation()
  const isTMA = useAppSelector(AppSelectors.selectIsTMA())

  const { data: influencer } = useGetMyInfluencerQuery()
  const refCode = influencer?.refCode

  const links = useMemo(
    () => (refCode ? buildReferralLinks(refCode) : undefined),
    [refCode]
  )

  const handleShare = () => {
    if (!links) return
    shareReferral({ links, intro: t("referrals.friends.shareText") })
  }

  const handleCopy = () => {
    if (!links) return
    navigator.clipboard.writeText(isTMA ? links.tg : links.web)
    showToast.info(t("message.copied"))
  }

  const disabled = !links

  return (
    <aside className={styles.InviteHero}>
      <img
        className={styles.InviteHero_image}
        src={friendsHeroSrc}
        alt=""
        aria-hidden="true"
      />
      <div className={styles.InviteHero_copy}>
        <p className={styles.InviteHero_title}>
          {t("referrals.friends.hero.title")}
        </p>
        <p className={styles.InviteHero_rewards}>
          <Ton3dIcon className={styles.InviteHero_rewardIcon} />
          <span>{t("referrals.friends.hero.tonReward")}</span>
          <span className={styles.InviteHero_rewardAnd}>&</span>
          <StarIcon className={styles.InviteHero_rewardIcon} />
          <span>{t("referrals.friends.hero.starsReward")}</span>
        </p>
      </div>
      <div className={styles.InviteHero_actions}>
        <Button onClick={handleShare} disabled={disabled}>
          {t("referrals.friends.hero.share")}
        </Button>
        <Button onClick={handleCopy} styles="orange" disabled={disabled}>
          {t("referrals.friends.hero.copyLink")}
        </Button>
      </div>
    </aside>
  )
}
